<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled"   :inline="true"
				label-width="100px">

				<el-row v-for="(itm,idx) in ansrArr" :key="idx">
					<el-col :span="24"  v-if="idx==0"  >
						<el-form-item    :label="'标准答案'"  >
							<el-input :rows="4" type="textarea" v-model="itm.ansr"
								autocomplete="off">
							</el-input>
						</el-form-item>
					</el-col>
					<span v-else>
						<el-col :span="22"    >
						   <el-form-item  :label="'判题模型 - '+idx"  >
							<el-input :rows="4" type="textarea" v-model="itm.ansr"
								autocomplete="off">
							</el-input>
						  </el-form-item>
					     </el-col>
					     <el-col :span="2"    >
						    <el-button size="mini" type="danger" @click="deleteAt(idx)"  >删除</el-button>
					     </el-col>
					</span>
				
				</el-row>


			</el-form>
		</div>

		<div slot="footer">
			<el-button  type="primary" :loading="confirmLoading" @click="confirm()">写入</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/exams/question/question.js';
import wangEditQu from "@/components/wangEdit/wangEditQu.vue";

export default {
	name: 'edit',
	components: {
		popup,
		wangEditQu
	},
	data() {
		return {

			title: '',
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			queID: '',
			ansrArr: [],
	 
		};
	},

	methods: {

		//打开弹框b
		open(parameter, title, disabled, size) {
			this.queID = parameter;
			this.title = title;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
			    this.init();
			});

		}, init() {

			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.ansrArr = [];
	 
			//查询数据
			api.listJudgeAnsr({id: this.queID}, response => {
				let   datas  = response.data;

				datas.forEach(element => {
					this.ansrArr.push({ansr:element})
				});

				this.popupLoading = false;
			});

		},deleteAt(idx){

			this.$utils.confirm.warning('警告提示', '确定删除第'+idx+'条吗？', () => {
				this.ansrArr.splice(idx,1)
			})
		
		},


		//关闭弹框
		close() {
			this.disabled = false;

			this.$refs.popup.close();


		}, reset() {
			this.popupLoading = false;
			//清除等待
			this.confirmLoading = false;
	 
		},
		//提交表单
		confirm() {
		 
				this.confirmLoading = true;
                        let params =[]
				this.ansrArr.forEach(v=>{
					params.push(v.ansr)
				})
				api.updateJudgeAnsr({id: this.queID,anrArrs: params  }, response => {
					this.confirmLoading = false;
				      this.close()
				     
			        });


			 
		}


	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';

.content-html {
	border: 1px solid #c9d8db !important;
	padding: 0px 20px;
}
</style>
